import { EntityGridList } from "@/modules/common/components";
import { Pagination } from "@/modules/common/types/Pagination";
import { AdminAneelTariffResponse } from "@/service/response/admin-aneel-tariffs";

import TariffsListHeader from "./TariffsListHeader";
import TariffsListLine from "./TariffsListLine";
import TariffsListSkeleton from "./TariffsListSkeleton";

interface TariffsListProps {
  data?: Pagination<AdminAneelTariffResponse>;
  isLoading?: boolean;
  isFetching?: boolean;
  limit?: number;
  onChangePage: (nextPage: number) => void;
  onChangePageSize: (nextSize: number) => void;
}

const TariffsList = (props: TariffsListProps) => (
  <EntityGridList
    {...props}
    minWidthClassName="md:min-w-[1900px]"
    renderHeader={() => <TariffsListHeader />}
    renderRow={(tariff) => <TariffsListLine tariff={tariff} />}
    renderSkeleton={(limit) => <TariffsListSkeleton limit={limit} />}
  />
);

export default TariffsList;
